import { param } from 'jquery'
import apiService from '../apiService'

export const supplierManagementController = configService => {
  const service = apiService(configService)
  const URL_ADMIN = `cms/admin/supplier`
  return {
    getList: (
      params = {
        supplierType: 0,
        accountStatus: 0,
        approveStatus: 0,
        keyWord: '',
        page: 1,
        sortName: '',
        sortBy: 'asc',
        taxId: '',
      }
    ) => {
      const strSearch = encodeURIComponent(params.keyWord)
      return service.get({
        url:
          URL_ADMIN +
          '?supplier_type=' +
          params.supplierType +
          '&account_status=' +
          params.accountStatus +
          '&approve_status=' +
          params.approveStatus +
          '&keyword=' +
          strSearch +
          '&page=' +
          params.page +
          '&sort_name=' +
          params.sortName +
          '&tax_id=' +
          params.taxId +
          '&sort_by=' +
          params.sortBy,
      })
    },
    getByID: id => {
      return service.get({ url: URL_ADMIN + '/' + id })
    },
    createSupplier: params => {
      return service.post({
        url: URL_ADMIN,
        params,
      })
    },
    updateSupplier: params => {
      return service.put({
        url: URL_ADMIN,
        params,
      })
    },
    verifyTaxID: id => {
      return service.get({
        url: 'auth/admin/verifyTaxID/' + id,
      })
    },
    resendEmail: params => {
      return service.post({
        url: 'cms/admin/resendEmailSupplier',
        params,
      })
    },
    cancelInvite: params => {
      return service.put({
        url: URL_ADMIN + '/cancel_invite',
        params,
      })
    },
    reject: params => {
      return service.put({ url: URL_ADMIN + '/reject', params })
    },
    accountStatusInactive: params => {
      return service.put({ url: URL_ADMIN + '/inactive', params })
    },

    exportSupplier: params => {
      return service.exportFile({
        url: `cms/admin/supplier/excel?supplier_type=0&account_status=0&approve_status=0&keyword=&page=1&sort_name=tax_id&sort_by=asc`,
        params,
      })
    },

    getOnlineTemplateID: id => {
      return service.get({
        url: 'cms/supplier/online-templates/' + id,
      })
    },

    getOnlineComprehensiveID: (templateId, supplierId) => {
      return service.get({
        url:
          'cms/supplier/online-comprehensive/' + templateId + '/' + supplierId,
      })
    },

    addOnlineRespond: params => {
      return service.post({
        url: 'cms/supplier/online-templates/respond',
        params,
      })
    },
    upLoadFileOnlineRespond: formData => {
      return service.uploadFile({
        url: 'cms/supplier/file-online-assessments',
        formData,
      })
    },

    getRespond: (templateId, supplierId) => {
      return service.get({
        url:
          'cms/supplier/online-templates/respond/' +
          templateId +
          '/' +
          supplierId,
      })
    },

    downloadTempalteFile: id => {
      return service.downloadFile({
        url: `cms/supplier/buyer/template/file-online-assessments/${id}/download`,
      })
    },

    downloadFileAnswer: id => {
      return service.downloadFile({
        url: `cms/supplier/answer/file-online-assessments/${id}/download`,
      })
    },
    checkLink: (templateId, supplierId, requestDate) => {
      return service.get({
        url:
          'cms/supplier/online-comprehensive/check-response/' +
          templateId +
          '/' +
          supplierId +
          '/' +
          requestDate,
      })
    },
  }
}

export const supplierManagementBuyerController = configService => {
  const service = apiService(configService)
  const URL_GET_BUYER = `/cms/buyer/mysupplier/management`
  const URL_UPDATE_BUYER = `cms/buyer/mysupplier/update`
  const URL_DOWNLOAD_SUPPLIER_TEMPLATE = `/cms/buyer/mysupplier/form/download`
  const URL_DOWNLOAD_SUPPLIER = `cms/buyer/offline/mysupplier/form/download`
  const URL_UPLOAD_SUPPLIER = `cms/buyer/mysupplier/form/upload`
  const URL_GET_BY_ID_BUYER = `/cms/buyer/mySupplier`
  // const URL_DELETE_BUYER = `/cms/supplier/delete`
  const URL_RESEND_EMAIL_SUPLLIER = `/cms/buyer/supplier/resendEmail`
  return {
    getList: (
      params = {
        keyWord: '',
        page: 1,
        sortName: '',
        sortBy: 'asc',
        status: '',
        offline_status: '',
      }
    ) => {
      const strSearch = encodeURIComponent(params.keyWord)
      return service.get({
        url:
          URL_GET_BUYER +
          '?keyword=' +
          strSearch +
          '&page=' +
          params.page +
          '&sort_name=' +
          params.sortName +
          '&sort_by=' +
          params.sortBy +
          '&status_supplier=' +
          params.status +
          '&offline_status=' +
          params.offline_status +
          '&status_active=' +
          params.status_active,
      })
    },
    getByID: id => {
      return service.get({ url: URL_GET_BY_ID_BUYER + '/' + id })
    },
    updateSupplier: params => {
      if (params.files && Array.isArray(params.files)) {
        params.files = params.files.map(f => f.files)
      }
      return service.putFormData({
        url: URL_UPDATE_BUYER,
        params,
      })
    },
    deleteSuppilier: id => {
      // return service.put({ url: URL_DELETE_BUYER + '/' + id })
      return service.delete({ url: `/cms/buyer/supplier/${id}` })
    },
    downloadSupplier: params => {
      return service.downloadFile({
        url: URL_DOWNLOAD_SUPPLIER,
        params,
      })
    },
    downloadTemplateSupplier: params => {
      return service.downloadFile({
        url: URL_DOWNLOAD_SUPPLIER_TEMPLATE,
        params,
      })
    },

    downloadAttachment: id => {
      return service.downloadFile({
        url: `/cms/buyer/file-supplier-discovery/${id}/download`,
      })
    },

    uploadSupplier: formData => {
      return service.uploadFileSupplier({
        url: URL_UPLOAD_SUPPLIER,
        formData,
      })
    },

    resendEmailSupplier: params => {
      return service.post({
        url: URL_RESEND_EMAIL_SUPLLIER,
        params,
      })
    },

    sendEmailOnlineTemplate: id => {
      return service.post({
        url: 'cms/buyer/online-templates/send-mail/' + id,
      })
    },
  }
}
